<template>
	<div class="c-bookmark-renderer">
		<a class="c-bookmark-renderer__inner" target="_blank" :href="note.ref">
			<div class="c-bookmark-renderer__cover">
				<img v-if="cover" :src="cover" />
			</div>
			<article class="c-bookmark-renderer__body" v-if="note">
				<div class="c-bookmark-renderer__subtext">
					<img v-if="logo" :src="logo" />
					<span :title="note.ref">
						{{ prettifyDomain(note.ref) }}
					</span>
				</div>

				<h5 v-if="title">{{ title }}</h5>
				<div class="c-bookmark-renderer__text">
					<p v-if="description">{{ description }}</p>
				</div>
			</article>
		</a>
	</div>
</template>

<script>
export default {
	props: ['note'],
	computed: {
		title: function () {
			if (
				this.note.meta &&
				this.note.meta._bookmark &&
				this.note.meta._bookmark.title
			) {
				return this.note.meta._bookmark.title;
			} else {
				return '';
			}
		},
		description: function () {
			if (
				this.note.meta &&
				this.note.meta._bookmark &&
				this.note.meta._bookmark.description
			) {
				return this.note.meta._bookmark.description;
			} else {
				return '';
			}
		},
		logo: function () {
			if (
				this.note.meta &&
				this.note.meta._bookmark &&
				this.note.meta._bookmark.logo
			) {
				return this.note.meta._bookmark.logo;
			} else {
				return null;
			}
		},
		cover: function () {
			if (
				this.note.meta &&
				this.note.meta._bookmark &&
				this.note.meta._bookmark.cover
			) {
				return this.note.meta._bookmark.cover;
			} else {
				return null;
			}
		},
	},
	methods: {
		prettifyDomain: function (link) {
			let url = new URL(link);
			if (url.pathname !== '/') {
				return url.host + url.pathname;
			} else {
				return url.host;
			}
		},
	},
};
</script>

<style lang="scss">
.c-bookmark-renderer {
	&__inner {
		display: grid;
		grid-template-columns: 160px 1fr;
		grid-template-rows: 1fr;
		gap: 0px 0px;
		grid-template-areas: '. .';
		border-radius: 5px;
		border: var(--g3) solid 1px;
		overflow: hidden;
		cursor: pointer;
		color: var(--body-color);
		background-color: var(--g4);
		transition: color var(--transition-time-sm) linear;
	}

	&__cover {
		position: relative;
		display: inline-block;
		height: 100%;
		background-color: var(--g3);

		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: center center;
		}
	}

	&__body {
		padding: var(--spacer-sm);
		font-size: var(--font-size-sm);
		white-space: initial;
	}

	&__subtext {
		display: flex;
		font-size: var(--font-size-xs);
		margin-bottom: 4px;
		opacity: 0.75;
		word-break: break-all;
		white-space: initial;

		img {
			width: var(--spacer-sm);
			height: var(--spacer-sm);
			object-fit: cover;
			margin-right: 4px;
			background-color: var(--g3);
		}
	}

	h5 {
		margin-bottom: 4px;
	}

	@include media-breakpoint-down(sm) {
		&__inner {
			grid-template-columns: 100px 1fr;
		}

		&__text {
			display: none;
		}
	}
}
</style>